var React = require('react');

function Church (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M620.61 366.54L512 320v192h112a16 16 0 0 0 16-16V396a32 32 0 0 0-19.39-29.46zM0 396v100a16 16 0 0 0 16 16h112V320L19.39 366.54A32 32 0 0 0 0 396z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M480 274.12V512h-96v-96a64 64 0 0 0-128 0v96h-96V274.12a32 32 0 0 1 15.54-27.44L288 179.2V128h-48a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h48V16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v48h48a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-48v51.2l112.46 67.48A32 32 0 0 1 480 274.12z","className":"fa-primary","key":2})]);
}

Church.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Church;

Church.default = Church;
